import { getMetadata } from '../../../../scripts/utils/aem-utils.js';

export default function updateImagePath(picture) {
  if (!window.location.origin.endsWith('.cn')) {
    return;
  }

  const base = getMetadata('edge-domain');

  picture.querySelectorAll('img, source').forEach((el) => {
    const pathname = new URL(el.src || el.srcset, window.location.origin)
      .pathname;
    const imagePath = new URL(pathname, base).href;

    if (el.tagName.toLowerCase() === 'img') {
      el.setAttribute('src', imagePath);
    } else {
      el.setAttribute('srcset', imagePath);
    }
  });
}
